export interface FAQItem {
  q: string;
  a: string;
}

export interface FAQSection {
  id:    string;
  title: string;
  items: FAQItem[];
}

export const FAQ_SECTIONS: FAQSection[] = [
  {
    id:    "platform-basics",
    title: "Platform Basics",
    items: [
      {
        q: "What is AI Ready Ohio?",
        a: "AI Ready Ohio is a statewide initiative to track certificate earners across Ohio's AI workforce development programs. It monitors employment changes and helps program coordinators understand the long-term impact of their training efforts.",
      },
      {
        q: "How does employment tracking work?",
        a: "When a certificate is imported, the system records the person's LinkedIn baseline company. A background scraper periodically checks their LinkedIn profile and compares the current employer against that baseline. If a change is detected within the tracking window, it is flagged as a job change.",
      },
      {
        q: "What is the tracking window?",
        a: "Each certificate has a 'Track Until' date. The scraper actively monitors the person's employment until that date. After it passes, tracking stops automatically.",
      },
      {
        q: "What does 'Company at Enrollment' mean?",
        a: "This is the company scraped from the person's LinkedIn profile at the time their certificate was imported. It serves as the baseline for detecting future employment changes.",
      },
    ],
  },
  {
    id:    "certificates",
    title: "Certificates",
    items: [
      {
        q: "What file formats does the importer accept?",
        a: "The importer accepts .csv, .xlsx, and .xls files. The file must contain at minimum the columns: email, certificate_name, and earned_date.",
      },
      {
        q: "What is the difference between AI Week and External certificate types?",
        a: "AI Week certificates are tied to Ohio AI Week events and include event name and event date fields. External certificates come from third-party training providers and do not require event information.",
      },
      {
        q: "What does 'Needs Review' mean?",
        a: "A certificate is flagged for manual review when the scraper detects ambiguous data or when the system cannot confidently determine whether a company change occurred. Reviewers can inspect and clear the flag from the Manual Review page.",
      },
      {
        q: "Can I manually mark a company change?",
        a: "Yes. On the Certificate Detail page, open the Edit Certificate panel and set 'Company Changed' to 'Yes'. This will also lock tracking status to Stopped.",
      },
    ],
  },
  {
    id:    "tracking",
    title: "Managing Tracking",
    items: [
      {
        q: "What happens when a LinkedIn URL is missing?",
        a: "If no LinkedIn URL is on file, tracking is paused with a 'No LinkedIn URL' stop reason. You can add the LinkedIn URL directly from the Person Detail page to resume tracking.",
      },
      {
        q: "How do I reactivate a stopped certificate?",
        a: "From the Person Detail page, use the Reactivate button next to the certificate. This clears the stop reason, resets scrape failures, and schedules the next snapshot.",
      },
    ],
  },
];
